import React, { useCallback, useEffect, useState } from 'react';

import { makeStyles }  from '@material-ui/core/styles';
import Button          from '@material-ui/core/Button';
import DialogActions   from '@material-ui/core/DialogActions';
import DialogContent   from '@material-ui/core/DialogContent';
import Table           from '@material-ui/core/Table';
import TableBody       from '@material-ui/core/TableBody';
import TableCell       from '@material-ui/core/TableCell';
import TableContainer  from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow        from '@material-ui/core/TableRow';
import Typography      from '@material-ui/core/Typography';

import { IssuedTicket } from '../ticket';
import { create } from '../util';

const style = {
  usedTicketsToAttend: makeStyles((theme) => ({
    note: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    ticket: {
      alignItems: 'center',
      color: 'gray',
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
      height: '100%',
      whiteSpace: 'nowrap',
    },
    title: {
      paddingBottom: theme.spacing(2),
    },
  })),
};

export default function UsedTicketsToAttend(props) {
  const classes = style.usedTicketsToAttend();

  const [ count, setCount ] = useState(0);
  const [ page, setPage ] = useState(0);
  const [ usedTickets, setUsedTickets ] = useState([]);

  const { request } = props.context.getStates();

  const fetchUsedTickets = useCallback((page) => {
    request.postSecurely('/attender/issued/used', {
      attender: props.attender.rowid,
      page,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        if ('count' in response) {
          setCount(response.count);
        }
        if ('tickets' in response) {
          setUsedTickets(response.tickets);
        }
      }
    });
  }, [
    request,
    props.attender.rowid
  ]);

  useEffect(() => {
    fetchUsedTickets(page);
  }, [fetchUsedTickets, page]);

  return (<>
    <DialogContent className={classes.dialogContent}>
      <TableContainer>
        <Table>
          <TableBody>
            {usedTickets.map((ticket) => (
              <TableRow hover tabIndex={-1} key={ticket['issued.rowid']}>
                <TableCell style={{padding: 5}}>
                  <IssuedTicket ticket={create.issuedTicket({
                    color: ticket['ticket.color'],
                    name: ticket['ticket.name'],
                    note: ticket['issued.note'],
                    paidMethod: ticket['paid.method'],
                    rowid: ticket['issued.rowid'],
                    usable: ticket['issued.usable'],
                    usedAt: ticket['issued.used_at'],
                    // "issued.date": 1643437200000
                  })} />
                </TableCell>
                <TableCell style={{padding: 5}}>
                  {ticket['issued.note'].split('\n').map((line, index) => (
                    <Typography variant="body1" key={index}
                      color="textSecondary"
                    >{line}</Typography>
                  ))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={count}
        onPageChange={(event, newPage) => { fetchUsedTickets(newPage); setPage(newPage); }}
        page={page}
        rowsPerPage={5}
        rowsPerPageOptions={[]}
      />
    </DialogContent>

    <DialogActions>
      <Button onClick={(event) => { props.setQuickAttending(create.quickAttending()); }}>
        {'닫기'}
      </Button>
    </DialogActions>
  </>);
}